import React, { useEffect } from 'react';
import { useOperatorPilotContext } from 'src/contexts/operator-pilot.context';
import { actionTypes } from 'src/ducks/operator-pilot.duck';
import { getOperatorPilotStatus } from 'src/selectors/operator-pilot.selector';
import OperatorPilotsView from './operator-pilot-relationship-list.view';

const OperatorPilots: React.FC = () => {
  const { state, actions } = useOperatorPilotContext();

  useEffect(() => {
    actions.listGET();
  }, [actions]);

  return (
    <OperatorPilotsView
      loading={
        getOperatorPilotStatus(state, actionTypes.OPERATOR_PILOT_FETCH).fetching
      }
      data={state.list}
    />
  );
};

export default OperatorPilots;
